import React, { useContext } from "react";
import { LanguageContext } from "../../../../Contexts/LanguageContext";
import './Form.css';

export default class MyForm extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.state = {
            status: ""
        };
    }
    render() {
        const { status } = this.state;
        // const [isBangla, setIsBangla] = useContext(LanguageContext)
        const isBangla = this.context[0];
        return (
            <form
                onSubmit={this.submitForm}
                action="https://formspree.io/f/xknprypa"
                method="POST"
            >
                {/* <!-- add your custom form HTML here --> */}
                <div className="container">
                    <label style={{ fontSize: '18px' }}>{isBangla ? <span>নাম <span style={{ color: '#f14b4d' }}>(প্রয়োজন)</span> :</span> : <span>Name <span style={{ color: '#f14b4d' }}>(Required)</span> :</span>}</label>
                    <input type="text" name="Name" className='form-control mb-3' placeholder='Enter Your Name' required />
                    <label style={{ fontSize: '18px' }}>{isBangla ? <span>ইমেইল <span style={{ color: '#f14b4d' }}>(প্রয়োজন)</span> :</span> : <span>Email <span style={{ color: '#f14b4d' }}>(Required)</span> :</span>}</label>
                    <input type="email" name="Email" className='form-control mb-3' placeholder='Enter Your Email' required />
                    <label style={{ fontSize: '18px' }}>{isBangla ? <span>ম্যাসেজ <span style={{ color: '#f14b4d' }}>(প্রয়োজন)</span> :</span> : <span>Message <span style={{ color: '#f14b4d' }}>(Required)</span> :</span>}</label>
                    <textarea type="text" name="Message" className='form-control mb-3' rows={3} placeholder='Tell Us Your Message' required />
                    <label style={{ fontSize: '18px' }}>{isBangla ? <span>মোবাইল নং <span style={{ color: '#4871FF' }}>(ঐচ্ছিক)</span> :</span> : <span>Phone number with country code <span style={{ color: '#4871FF' }}>(Optional)</span> :</span>}</label>
                    <input type="text" name="Phone" className='form-control mb-3' placeholder='Enter Your Phone Number' />
                    {status === "SUCCESS" ? <p className='mt-4' style={{ color: 'black' }}>Thanks For Your Message! Your Message Is Successfully Submitted!</p> : <button className='submit-btn mt-3 mb-4'>{isBangla ? "জমা দিন" : "Submit"}</button>}
                    {status === "ERROR" && <p style={{ color: 'black' }}>Oops! There was an error. Please Try Again</p>}
                </div>
            </form>
        );
    }

    submitForm(ev) {
        ev.preventDefault();
        const form = ev.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                this.setState({ status: "SUCCESS" });
            } else {
                this.setState({ status: "ERROR" });
            }
        };
        xhr.send(data);
    }
}